import { AppBar, IconButton, Toolbar } from '@material-ui/core';
import ArrowBack from '@material-ui/icons/ArrowBack';
import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { BrandHeader } from 'components/BrandHeader';
import { Footer } from 'features/Footer';
import { getLogoUrl } from 'utils/brandLogoUrl';
import { domainMeta } from 'utils/domainMeta';

import { useStyles } from './styles';

export interface ApplicationFormLayoutProps {
  brandLogo: string | null;
  brandName: string;
  helpEmail?: string;
  children?: React.ReactNode;
  hideBackButton: boolean;
  accountSlug: string;
  amazonAccount?: boolean;
  isDspBrand?: boolean;
  languageSelector?: ReactNode;
  languageBanner?: ReactNode;
}

export const ApplicationFormLayout: React.FC<ApplicationFormLayoutProps> = ({
  brandLogo,
  brandName,
  children,
  helpEmail,
  hideBackButton,
  accountSlug,
  amazonAccount,
  isDspBrand,
  languageSelector,
  languageBanner,
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const logoUrl = getLogoUrl(brandLogo);
  const showBackButton = (!hideBackButton && !amazonAccount) || isDspBrand;

  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.appBar} elevation={0}>
        <Toolbar>
          {showBackButton && (
            <IconButton
              edge="start"
              href={
                isDspBrand
                  ? `${domainMeta.monolithOrigin}/jobs/${accountSlug}`
                  : `${domainMeta.monolithOrigin}/c/${accountSlug}`
              }
              aria-label={intl.formatMessage({
                defaultMessage: 'Back to Job Directory Icon',
                description:
                  'Allows users to go back to Job Directory by clicking the Back Arrow icon',
              })}
            >
              <ArrowBack />
            </IconButton>
          )}
          <div className={classes.logo}>
            {logoUrl && <BrandHeader brandName={brandName} logoUrl={logoUrl} />}
          </div>
          <div className={classes.languageSelector}>{languageSelector}</div>
        </Toolbar>
      </AppBar>
      {languageBanner && (
        <>
          <div className={classes.toolbar} />
          {languageBanner}
        </>
      )}
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <div className={classes.form}>{children}</div>
      </main>
      <Footer helpEmail={helpEmail} isAmazonAccount={amazonAccount} />
    </div>
  );
};
